import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-intelligent",
  "use": "icon-intelligent-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-intelligent\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M5,15v4H9V15ZM5,5V9H9V5Zm14,8h2v8H19Zm-6,0h2v8H13Zm2-8V9h4V5ZM13,3h8v8H13ZM3,13h8v8H3ZM3,3h8v8H3Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol